import { motion } from "framer-motion";

// Single slot tile. Extracted from GameBoard for readability and cheaper re-renders.
export default function LetterTile({
  slot,
  slotIndex,
  isActive,
  onClick,
}) {
  const isLocked = slot.locked;
  const isErrored = slot.errored;
  const hasChar = slot.char !== "";

  let cls =
    "relative w-9 h-11 md:w-12 md:h-14 flex items-center justify-center font-serif-display text-xl md:text-3xl font-bold uppercase select-none transition-colors";
  if (isLocked) {
    cls +=
      " bg-[#0F5132] text-[#F4F1EA] border-2 border-[#0F5132] shadow-[2px_2px_0px_#0A3622] rounded-sm cursor-default";
  } else if (isErrored) {
    cls +=
      " bg-[#842029] text-[#F4F1EA] border-2 border-[#842029] rounded-sm animate-shake cursor-default";
  } else if (hasChar) {
    cls +=
      " bg-[#F4F1EA] text-[#1A1A1A] border-2 border-[#1A1A1A] rounded-sm shadow-[1px_1px_0px_#1A1A1A] cursor-pointer hover:-translate-y-0.5 transition-transform";
    if (isActive) {
      cls += " ring-2 ring-[#EB5E28] ring-offset-2 ring-offset-[#F4F1EA]";
    }
  } else if (isActive) {
    cls += " border-b-4 border-[#EB5E28] bg-[#EB5E28]/10 cursor-pointer";
  } else {
    cls += " border-b-4 border-[#1A1A1A]/40 cursor-pointer hover:border-[#1A1A1A]";
  }

  const animate = isLocked
    ? { scale: [1, 1.12, 1] }
    : hasChar && !isErrored
    ? { scale: [1.1, 1] }
    : { scale: 1 };

  return (
    <motion.button
      layout
      onClick={() => !isLocked && !isErrored && onClick(slotIndex)}
      className={cls}
      data-testid={`board-tile-${slotIndex}`}
      disabled={isLocked || isErrored}
      initial={false}
      animate={animate}
      transition={{ duration: 0.28 }}
    >
      {slot.char || ""}
    </motion.button>
  );
}
